import { memo } from 'react';

import ProfileSettingsIconSVG from '@/assets/profile-settings-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IProfileSettingsIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ProfileSettingsIconSVG} {...props} />
);

export const ProfileSettingsIcon = memo(IProfileSettingsIcon) as typeof IProfileSettingsIcon;
